import { default as indexAbfUaRHgjVMeta } from "E:/W2/VM/VM.Cms/pages/academic-year/index.vue?macro=true";
import { default as index1O0ZknQOAwMeta } from "E:/W2/VM/VM.Cms/pages/account/index.vue?macro=true";
import { default as loginVbBSaE318FMeta } from "E:/W2/VM/VM.Cms/pages/account/login.vue?macro=true";
import { default as settingsX4NcfsB2O5Meta } from "E:/W2/VM/VM.Cms/pages/account/settings.vue?macro=true";
import { default as indexH6IpvaKUKDMeta } from "E:/W2/VM/VM.Cms/pages/activity-log/index.vue?macro=true";
import { default as indexL8D1xGosDeMeta } from "E:/W2/VM/VM.Cms/pages/bank-account/index.vue?macro=true";
import { default as builderOSECwcUr2vMeta } from "E:/W2/VM/VM.Cms/pages/builder.vue?macro=true";
import { default as _91type_93julDbVnNBKMeta } from "E:/W2/VM/VM.Cms/pages/category/[type].vue?macro=true";
import { default as indexa1ux8QtTvBMeta } from "E:/W2/VM/VM.Cms/pages/class/index.vue?macro=true";
import { default as indexmjcwUyEUI7Meta } from "E:/W2/VM/VM.Cms/pages/config/index.vue?macro=true";
import { default as index1GZbVGCR6PMeta } from "E:/W2/VM/VM.Cms/pages/fee-schedule/index.vue?macro=true";
import { default as indexNsEvfkEki2Meta } from "E:/W2/VM/VM.Cms/pages/index.vue?macro=true";
import { default as inputs2hsol2wBNMeta } from "E:/W2/VM/VM.Cms/pages/input.vue?macro=true";
import { default as indexHBlJdySLndMeta } from "E:/W2/VM/VM.Cms/pages/notifications/index.vue?macro=true";
import { default as parent_45inputTvm6lymh1lMeta } from "E:/W2/VM/VM.Cms/pages/parent-input.vue?macro=true";
import { default as indexnESPpIQgpRMeta } from "E:/W2/VM/VM.Cms/pages/receipt/index.vue?macro=true";
import { default as payment_45trackinghYdGkxib5GMeta } from "E:/W2/VM/VM.Cms/pages/receipt/payment-tracking.vue?macro=true";
import { default as indexQ5WXThBuY3Meta } from "E:/W2/VM/VM.Cms/pages/role/index.vue?macro=true";
import { default as indexNw2k5SpB3cMeta } from "E:/W2/VM/VM.Cms/pages/scholar-ship/index.vue?macro=true";
import { default as student_45statusaG9xVzyfUUMeta } from "E:/W2/VM/VM.Cms/pages/statistic/student-status.vue?macro=true";
import { default as indexS2hL9PBF7PMeta } from "E:/W2/VM/VM.Cms/pages/student/index.vue?macro=true";
import { default as file_45managerNnShp5jv7nMeta } from "E:/W2/VM/VM.Cms/pages/test/file-manager.vue?macro=true";
import { default as file_45viewerQFqP495pMZMeta } from "E:/W2/VM/VM.Cms/pages/test/file-viewer.vue?macro=true";
import { default as pdf2imageI2k8lIyAODMeta } from "E:/W2/VM/VM.Cms/pages/test/pdf2image.vue?macro=true";
import { default as student_45notification_45demoyhEw3ToWYzMeta } from "E:/W2/VM/VM.Cms/pages/test/student-notification-demo.vue?macro=true";
import { default as toast_45demoWBeKl44Wz5Meta } from "E:/W2/VM/VM.Cms/pages/test/toast-demo.vue?macro=true";
export default [
  {
    name: "academic-year___vi",
    path: "/academic-year",
    component: () => import("E:/W2/VM/VM.Cms/pages/academic-year/index.vue")
  },
  {
    name: "academic-year___en",
    path: "/en/academic-year",
    component: () => import("E:/W2/VM/VM.Cms/pages/academic-year/index.vue")
  },
  {
    name: "account___vi",
    path: "/account",
    component: () => import("E:/W2/VM/VM.Cms/pages/account/index.vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    component: () => import("E:/W2/VM/VM.Cms/pages/account/index.vue")
  },
  {
    name: "account-login___vi",
    path: "/account/login",
    meta: loginVbBSaE318FMeta || {},
    component: () => import("E:/W2/VM/VM.Cms/pages/account/login.vue")
  },
  {
    name: "account-login___en",
    path: "/en/account/login",
    meta: loginVbBSaE318FMeta || {},
    component: () => import("E:/W2/VM/VM.Cms/pages/account/login.vue")
  },
  {
    name: "account-settings___vi",
    path: "/account/settings",
    component: () => import("E:/W2/VM/VM.Cms/pages/account/settings.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account/settings",
    component: () => import("E:/W2/VM/VM.Cms/pages/account/settings.vue")
  },
  {
    name: "activity-log___vi",
    path: "/activity-log",
    component: () => import("E:/W2/VM/VM.Cms/pages/activity-log/index.vue")
  },
  {
    name: "activity-log___en",
    path: "/en/activity-log",
    component: () => import("E:/W2/VM/VM.Cms/pages/activity-log/index.vue")
  },
  {
    name: "bank-account___vi",
    path: "/bank-account",
    component: () => import("E:/W2/VM/VM.Cms/pages/bank-account/index.vue")
  },
  {
    name: "bank-account___en",
    path: "/en/bank-account",
    component: () => import("E:/W2/VM/VM.Cms/pages/bank-account/index.vue")
  },
  {
    name: "builder___vi",
    path: "/builder",
    component: () => import("E:/W2/VM/VM.Cms/pages/builder.vue")
  },
  {
    name: "builder___en",
    path: "/en/builder",
    component: () => import("E:/W2/VM/VM.Cms/pages/builder.vue")
  },
  {
    name: "category-type___vi",
    path: "/category/:type()",
    component: () => import("E:/W2/VM/VM.Cms/pages/category/[type].vue")
  },
  {
    name: "category-type___en",
    path: "/en/category/:type()",
    component: () => import("E:/W2/VM/VM.Cms/pages/category/[type].vue")
  },
  {
    name: "class___vi",
    path: "/class",
    component: () => import("E:/W2/VM/VM.Cms/pages/class/index.vue")
  },
  {
    name: "class___en",
    path: "/en/class",
    component: () => import("E:/W2/VM/VM.Cms/pages/class/index.vue")
  },
  {
    name: "config___vi",
    path: "/config",
    meta: indexmjcwUyEUI7Meta || {},
    component: () => import("E:/W2/VM/VM.Cms/pages/config/index.vue")
  },
  {
    name: "config___en",
    path: "/en/config",
    meta: indexmjcwUyEUI7Meta || {},
    component: () => import("E:/W2/VM/VM.Cms/pages/config/index.vue")
  },
  {
    name: "fee-schedule___vi",
    path: "/fee-schedule",
    component: () => import("E:/W2/VM/VM.Cms/pages/fee-schedule/index.vue")
  },
  {
    name: "fee-schedule___en",
    path: "/en/fee-schedule",
    component: () => import("E:/W2/VM/VM.Cms/pages/fee-schedule/index.vue")
  },
  {
    name: "index___vi",
    path: "/",
    component: () => import("E:/W2/VM/VM.Cms/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("E:/W2/VM/VM.Cms/pages/index.vue")
  },
  {
    name: "input___vi",
    path: "/input",
    component: () => import("E:/W2/VM/VM.Cms/pages/input.vue")
  },
  {
    name: "input___en",
    path: "/en/input",
    component: () => import("E:/W2/VM/VM.Cms/pages/input.vue")
  },
  {
    name: "notifications___vi",
    path: "/notifications",
    meta: indexHBlJdySLndMeta || {},
    component: () => import("E:/W2/VM/VM.Cms/pages/notifications/index.vue")
  },
  {
    name: "notifications___en",
    path: "/en/notifications",
    meta: indexHBlJdySLndMeta || {},
    component: () => import("E:/W2/VM/VM.Cms/pages/notifications/index.vue")
  },
  {
    name: "parent-input___vi",
    path: "/parent-input",
    meta: parent_45inputTvm6lymh1lMeta || {},
    component: () => import("E:/W2/VM/VM.Cms/pages/parent-input.vue")
  },
  {
    name: "parent-input___en",
    path: "/en/parent-input",
    meta: parent_45inputTvm6lymh1lMeta || {},
    component: () => import("E:/W2/VM/VM.Cms/pages/parent-input.vue")
  },
  {
    name: "receipt___vi",
    path: "/receipt",
    component: () => import("E:/W2/VM/VM.Cms/pages/receipt/index.vue")
  },
  {
    name: "receipt___en",
    path: "/en/receipt",
    component: () => import("E:/W2/VM/VM.Cms/pages/receipt/index.vue")
  },
  {
    name: "receipt-payment-tracking___vi",
    path: "/receipt/payment-tracking",
    component: () => import("E:/W2/VM/VM.Cms/pages/receipt/payment-tracking.vue")
  },
  {
    name: "receipt-payment-tracking___en",
    path: "/en/receipt/payment-tracking",
    component: () => import("E:/W2/VM/VM.Cms/pages/receipt/payment-tracking.vue")
  },
  {
    name: "role___vi",
    path: "/role",
    component: () => import("E:/W2/VM/VM.Cms/pages/role/index.vue")
  },
  {
    name: "role___en",
    path: "/en/role",
    component: () => import("E:/W2/VM/VM.Cms/pages/role/index.vue")
  },
  {
    name: "scholar-ship___vi",
    path: "/scholar-ship",
    component: () => import("E:/W2/VM/VM.Cms/pages/scholar-ship/index.vue")
  },
  {
    name: "scholar-ship___en",
    path: "/en/scholar-ship",
    component: () => import("E:/W2/VM/VM.Cms/pages/scholar-ship/index.vue")
  },
  {
    name: "statistic-student-status___vi",
    path: "/statistic/student-status",
    component: () => import("E:/W2/VM/VM.Cms/pages/statistic/student-status.vue")
  },
  {
    name: "statistic-student-status___en",
    path: "/en/statistic/student-status",
    component: () => import("E:/W2/VM/VM.Cms/pages/statistic/student-status.vue")
  },
  {
    name: "student___vi",
    path: "/student",
    component: () => import("E:/W2/VM/VM.Cms/pages/student/index.vue")
  },
  {
    name: "student___en",
    path: "/en/student",
    component: () => import("E:/W2/VM/VM.Cms/pages/student/index.vue")
  },
  {
    name: "test-file-manager___vi",
    path: "/test/file-manager",
    component: () => import("E:/W2/VM/VM.Cms/pages/test/file-manager.vue")
  },
  {
    name: "test-file-manager___en",
    path: "/en/test/file-manager",
    component: () => import("E:/W2/VM/VM.Cms/pages/test/file-manager.vue")
  },
  {
    name: "test-file-viewer___vi",
    path: "/test/file-viewer",
    component: () => import("E:/W2/VM/VM.Cms/pages/test/file-viewer.vue")
  },
  {
    name: "test-file-viewer___en",
    path: "/en/test/file-viewer",
    component: () => import("E:/W2/VM/VM.Cms/pages/test/file-viewer.vue")
  },
  {
    name: "test-pdf2image___vi",
    path: "/test/pdf2image",
    component: () => import("E:/W2/VM/VM.Cms/pages/test/pdf2image.vue")
  },
  {
    name: "test-pdf2image___en",
    path: "/en/test/pdf2image",
    component: () => import("E:/W2/VM/VM.Cms/pages/test/pdf2image.vue")
  },
  {
    name: "test-student-notification-demo___vi",
    path: "/test/student-notification-demo",
    meta: student_45notification_45demoyhEw3ToWYzMeta || {},
    component: () => import("E:/W2/VM/VM.Cms/pages/test/student-notification-demo.vue")
  },
  {
    name: "test-student-notification-demo___en",
    path: "/en/test/student-notification-demo",
    meta: student_45notification_45demoyhEw3ToWYzMeta || {},
    component: () => import("E:/W2/VM/VM.Cms/pages/test/student-notification-demo.vue")
  },
  {
    name: "test-toast-demo___vi",
    path: "/test/toast-demo",
    meta: toast_45demoWBeKl44Wz5Meta || {},
    component: () => import("E:/W2/VM/VM.Cms/pages/test/toast-demo.vue")
  },
  {
    name: "test-toast-demo___en",
    path: "/en/test/toast-demo",
    meta: toast_45demoWBeKl44Wz5Meta || {},
    component: () => import("E:/W2/VM/VM.Cms/pages/test/toast-demo.vue")
  }
]